// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DirectoryMgrOutlinedSvg from "@fishx/icons-svg/es/asn/DirectoryMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var DirectoryMgrOutlined = function DirectoryMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DirectoryMgrOutlinedSvg
  }));
};

DirectoryMgrOutlined.displayName = 'DirectoryMgrOutlined';
export default React.forwardRef(DirectoryMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DirectoryMgrOutlined.js
// module id = 2428
// module chunks = 0